import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { ContaService } from '../../../../../shared/services/conta/conta.service';
import { LocalStorageService } from '../../../../../shared/services/local-storage/local-storage.service';

declare var $;

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss']
})
export class ClientesComponent implements OnInit {
  public error = false;
  public success = false;

  public user = null;

  public table = null;

  public clients = [];
  public clientsBkp = [];

  constructor(
    private router: Router,
    private contaService: ContaService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.getAccountId();
    this.getClients();
  }

  getAccountId() {
    this.user = this.localStorageService.get('login');
  }

  getClients() {
    this.contaService.obterClientes(this.user.PersonId).subscribe((data: any[]) => {
      this.clients = data;
      this.clientsBkp = this.clients;
      this.mountTable();
    }, (err) => {
      console.error(err);
    });
  }

  mountTable() {
    if (this.table) { this.table.destroy(); }

    const self = this;

    $.fn.dataTable.moment('DD/MM/YYYY');

    this.table = $('#master-detail-table-clients').DataTable({
      info: true,
      paging: true,
      scrollX: true,
      destroy: true,
      searching: false,
      processing: false,
      data: self.clients,
      lengthChange: false,
      pagingType: 'numbers',
      language: { emptyTable: ' ', info: '_START_ - _END_ de _MAX_' },
      initComplete: function() {
        self.success = true;
        self.setNumberOfRegisters();
      },
      columns: [
        { title: 'Nome', data: 'Nome' },
        { title: 'Email', data: 'Email' },
        { title: 'CPF/CNPJ', data: 'CpfCnpj', render: function(data, type, row, meta) { return self.maskCpfCnpj(row.CpfCnpj); } }
      ]
    });

    this.onRowClick();
  }

  setNumberOfRegisters() {
    if (this.clients && this.clients.length === 0) {
      $('#master-detail-table-clients_info').html('0 - 0 de 0');
    }
  }

  onRowClick() {
    const self = this;
    $('#master-detail-table-clients tbody').on('click', 'tr', function(e) {
      const data = self.table.row(this).data();
      self.router.navigate(['/cliente/' + data.ClienteId]);
    });
  }

  filter(e) {
    this.clients = this.clientsBkp;

    if (e.target.value.length === 0) {
      this.mountTable();
      return;
    }

    this.clients = this.clients.filter((client) => {
      const name = client.Nome ? client.Nome.toLowerCase() : '';
      const email = client.Email ? client.Email.toLowerCase() : '';
      const value = e.target.value ? e.target.value.toLowerCase() : '';
      const cpfCnpj = client.CpfCnpj ? client.CpfCnpj.toLowerCase() : '';

      return name.indexOf(value) > -1 ||
             email.indexOf(value) > -1 ||
             cpfCnpj.indexOf(value) > -1 ?
             true :
             false;
    });

    this.mountTable();
  }

  maskCpfCnpj(cpfCnpj) {
    if (cpfCnpj && cpfCnpj.length === 11) {
      return this.cpfMask(cpfCnpj);
    }

    if (cpfCnpj && cpfCnpj.length === 14) {
      return this.cnpjMask(cpfCnpj);
    }

    return '';
  }

  cpfMask (value) {
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4');
  }

  cnpjMask (value) {
    return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/clientes/clientes/clientes.component.ts